import { render, staticRenderFns } from "./settingsPushNotifications.vue?vue&type=template&id=b3eb4616&scoped=true&"
import script from "./settingsPushNotifications.vue?vue&type=script&lang=js&"
export * from "./settingsPushNotifications.vue?vue&type=script&lang=js&"
import style0 from "./settingsPushNotifications.vue?vue&type=style&index=0&id=b3eb4616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3eb4616",
  null
  
)

export default component.exports